<template>
	<div ref="echartLine" style="width:100%;height:100%;">
	</div>
</template>
<script>
	import echarts from 'echarts'
	export default {
		name: 'echartLine',
		props: {
			echartLineData: {
				type: Array,
				default: []
			},
			lineXAxisData: {
				type: Array,
				default: []
			},

		},
		data() {
			return {
				series: [],
				legend: []
			}
		},
		mounted() {
			// this.initData();
			this.getEchart();
			window.addEventListener('resize', this.resize)
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.resize)
		},
		watch: {
			echartLineData(n, o) {
				this.$nextTick(() => {
					this.getEchart();
				});
			},
			lineXAxisData(n, o) {
				this.$nextTick(() => {
					this.getEchart();
				});
			}
		},
		methods: {
			resize(){
				this.myChart.resize()
			},
			initData() {

			},
			getEchart() {
				this.legend = []
				this.series = []
				this.echartLineData.forEach(t => {
					this.legend.push(t.name)
					let series = {
						name: t.name,
						type: 'line',
						data: t.value,
						smooth: true
					}
					this.series.push(series)
				})
				this.myChart = echarts.init(this.$refs.echartLine)
				let option = {
					legend: {
						data: this.legend
					},
					tooltip: {
						trigger: 'axis',
					},
					color: ['#6fb9fc', '#79d895', '#fde890', '#f09eab'],
					grid: {
						left: '1%',
						top: '10%',
						right: '3%',
						bottom: '4%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						data: this.lineXAxisData,
						// axisTick: {
						//     alignWithLabel: true
						// }
					},
					yAxis: {
						axisLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						type: 'value',
						splitLine: {
							show: true,
							lineStyle: {
								type: 'dashed'
							}
						}
					},
					series: this.series
				};
				this.myChart.setOption(option, true);
			}
		}
	}
</script>
